export default __webpack_public_path__ + "static/media/Graphite.225bf2fd.jpg";